import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../context/UserContext';
import { permissions } from '../../utils/permissions-utils';
import FloatingAddButton from '../../components/FloatingAddButton';
import CommonLayout from '../../components/CommonLayout';
import DeleteConfirmationDialog from '../../components/dialogs/DeleteConfirmationDialog';
import ChecklistTemplatesList from "./ChecklistTemplatesList";
import ChecklistInstancesList from "./ChecklistInstancesList";
import { deleteChecklistTemplate } from './checklistApi';
import './Checklists.scss';

function Checklists() {
    const { user } = useContext(UserContext);
    const navigate = useNavigate();
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [templateToDelete, setTemplateToDelete] = useState(null);
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const [deleteError, setDeleteError] = useState(null);
    const [dataLoaded, setDataLoaded] = useState(false);

    const canCreate = permissions.canCreate(user);

    const handleAddNew = () => {
        navigate('/checklists/templates/new');
    };

    const handleDeleteClick = (template) => {
        setTemplateToDelete(template);
        setDeleteError(null);
        setDeleteConfirmOpen(true);
    };

    const handleDeleteConfirm = async () => {
        if (!templateToDelete) return;

        try {
            await deleteChecklistTemplate(templateToDelete._id);
            setDeleteConfirmOpen(false);
            setTemplateToDelete(null);
            setRefreshTrigger(prev => prev + 1); // Trigger refresh
        } catch (error) {
            console.error('Failed to delete checklist template', error);
            setDeleteError('אירעה שגיאה במחיקת התבנית. אנא נסה שנית.');
        }
    };

    const handleDeleteCancel = () => {
        setDeleteConfirmOpen(false);
        setTemplateToDelete(null);
        setDeleteError(null);
    };

    return (
        <CommonLayout maxWidth="1200px">
            <div className="checklists-page">
                <section className="templates-section">
                    <ChecklistTemplatesList
                        onDelete={handleDeleteClick}
                        refreshTrigger={refreshTrigger}
                        onDataLoaded={setDataLoaded}
                        onAddNew={handleAddNew}
                        canCreate={canCreate}
                    />
                </section>

                <ChecklistInstancesList refreshTrigger={refreshTrigger} />

                {canCreate && (
                    <FloatingAddButton
                        onClick={handleAddNew}
                        entityName="רשומה"
                        dataLoaded={dataLoaded}
                    />
                )}

                <DeleteConfirmationDialog
                    open={deleteConfirmOpen}
                    onClose={handleDeleteCancel}
                    onConfirm={handleDeleteConfirm}
                    title={`האם אתה בטוח שברצונך למחוק את התבנית "${templateToDelete?.name}"?`}
                    showError={!!deleteError}
                    errorMessage={deleteError}
                    onCloseError={() => setDeleteError(null)}
                />
            </div>
        </CommonLayout>
    );
}

export default Checklists;